export const avatarImages = {
    Anoob: "/assets/img/Anoob.png",
    Baiju: "/assets/img/Baiju.png",
    Ranish: "/assets/img/Ranish.png",
    Shanavas: "/assets/img/Shanavas.png",
    Shiju: "/assets/img/Shiju.png",
    Swami: "/assets/img/Swami.png",
}

//{process.env.PUBLIC_URL + "/assets/img/Anoob.png"}